import {Source, useMap, Layer} from 'react-map-gl';
import {ClusteredPointsProps, isFillPaint, isSymbolPaint, LayerProps} from './types';
import {useState, useEffect} from 'react';

export default function ClusteredPoints(props: LayerProps & ClusteredPointsProps) {
    const {data, id, paint, layout, clusterProperties = [], clusterMaxZoom = 14, clusterRadius = 28} = props;
    const color = isFillPaint(paint) ? paint?.['fill-color'] : undefined;

    const {current: map} = useMap();
    const [, setZoom] = useState(map ? map.getZoom() : 1);

    useEffect(() => {
        if (map) {
            const handleZoom = () => {
                setZoom(map.getZoom());
            };

            map.on('zoom', handleZoom);

            return () => {
                map.off('zoom', handleZoom);
            };
        }
    }, [map]);

    const iconSize = 0.375;
    return (
        <Source id={String(id)} key={id} type='geojson' cluster={true} clusterMaxZoom={clusterMaxZoom}
            clusterRadius={clusterRadius} clusterProperties={clusterProperties.reduce((prev, curr) => (
                {...prev, [curr]: [['concat', ['get', curr], ['concat', '|', ['accumulated']]], ['get', curr]]}
            ), {})} data={data}>
            <Layer
                id={String(id)}
                type='symbol'
                layout={{'icon-image': 'map-pin',
                    'icon-size': iconSize,
                    'icon-allow-overlap': true, 
                    'icon-ignore-placement': true, 
                    ...layout
                }}
                paint={isSymbolPaint(paint) ? paint : {'icon-color': color}}
            />
            <Layer
                id={`${String(id)}_clusters`}
                type='circle'
                filter={['has', 'point_count']}
                paint={{
                    'circle-color': isSymbolPaint(paint) && paint?.['icon-color'] ? paint?.['icon-color'] : color,
                    'circle-radius': ['step', ['get', 'point_count'], 6, 10, 8, 33, 10, 66, 12, 100, 14]
                }}
            />
            <Layer
                id={`${String(id)}_cluster_count`}
                type='symbol'
                filter={['has', 'point_count']}
                layout={{
                    'text-field': '{point_count_abbreviated}',
                    'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
                    'text-size': ['step', ['get', 'point_count'], 8, 10, 10, 100, 12],
                    'text-allow-overlap': true
                }}
                paint={{
                    'text-color': 'rgba(0, 0, 0, 0.7)'
                }}
            />
        </Source>
    );
}
